import React from 'react';

const UserVideos = ({ videos, loading, onVideoSelect, onVideoDelete }) => {
    if (loading) {
        return (
            <div className="loading-container">
                <div className="modern-spinner"></div>
                <p>Loading your videos...</p>
            </div>
        );
    }

    if (!videos || videos.length === 0) {
        return (
            <div className="empty-videos">
                <div className="empty-icon">📹</div>
                <h3>No videos uploaded yet</h3>
                <p>Upload your first video to see it here</p>
            </div>
        );
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const formatFileSize = (bytes) => {
        if (!bytes) return 'Unknown size';
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
    };

    return (
        <div className="user-videos-grid">
            {videos.map((video) => (
                <div key={video.id} className="user-video-card">
                    <div 
                        className="user-video-thumbnail"
                        onClick={() => onVideoSelect(video)}
                    >
                        {video.thumbnail || video.thumbnailPath ? (
                            <img src={video.thumbnail || video.thumbnailPath} alt={video.videoTitle || video.title} />
                        ) : (
                            <div className="thumbnail-placeholder">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M8 5v14l11-7z"/>
                                </svg>
                            </div>
                        )}
                        <div className="video-duration">
                            {video.duration || '0:00'}
                        </div>
                    </div>
                    
                    <div className="user-video-info">
                        <h4 className="user-video-title" title={video.videoTitle || video.title}>
                            {video.videoTitle || video.title}
                        </h4>
                        
                        <div className="video-meta-row">
                            <span className="video-date">
                                {formatDate(video.uploadDate)}
                            </span>
                            <span className="video-size">
                                {formatFileSize(video.fileSize || video.size)}
                            </span>
                        </div>
                        
                        <div className="video-stats">
                            <span className="stat-item">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                                </svg>
                                {video.views || 0} views
                            </span>
                            <span className="stat-item">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/>
                                </svg>
                                {video.likes || 0}
                            </span>
                        </div>
                        
                        <div className="video-actions">
                            <button 
                                className="video-action-btn edit-btn"
                                title="Edit video details"
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                                </svg>
                            </button>
                            <button 
                                className="video-action-btn delete-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (window.confirm(`Delete "${video.videoTitle || video.title}"?`)) {
                                        onVideoDelete(video);
                                    }
                                }}
                                title="Delete video"
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default UserVideos;